import type { TFunction } from "i18next";

/**
 * Chaves i18n dos módulos operacionais canônicos (`modules.module` no tenant).
 * Fonte: docs/prd/operational-modules/operational-modules.md §4.
 * Rótulos vivem em `sidebar.modules.*` (reutilizados fora da sidebar).
 */
export const OPERATIONAL_MODULE_I18N_KEYS: Record<string, string> = {
  General: "sidebar.modules.general",
  Monitoring: "sidebar.modules.monitoring",
  Inspection: "sidebar.modules.inspection",
  "Action plan": "sidebar.modules.actionPlan",
  "Stability analysis": "sidebar.modules.stabilityAnalysis",
  EoR: "sidebar.modules.eor",
  ATO: "sidebar.modules.ato",
  PSB: "sidebar.modules.psb",
  GISTM: "sidebar.modules.gistm",
  PAEBM: "sidebar.modules.paebm",
  "Dam Break Study": "sidebar.modules.damBreakStudy",
  "Risk Analysis": "sidebar.modules.riskAnalysis",
};

/** Traduz o valor canônico `module`/`moduleName` vindo do backend para o locale ativo. */
export const translateOperationalModule = (
  module: string | undefined | null,
  translate: TFunction | ((key: string) => string),
): string => {
  if (!module) return "";
  const i18nKey = OPERATIONAL_MODULE_I18N_KEYS[module];
  return i18nKey ? translate(i18nKey) : module;
};
